/**
 * Where each plane is served, for the links that cross between them.
 *
 * The three planes are three origins -- the landing at the apex, the tenant
 * application at `app.`, the operator plane at `ops.` -- so a link from one to
 * another cannot be a path. Within a plane nothing here is needed: a path is
 * the whole address, which is why only three links in the repository import
 * this.
 *
 * Overridable per build because local development serves the same three planes
 * at `*.localhost`, and a deploy preview serves them at their `*.web.app`
 * names; the defaults are the production hosts so a build that sets nothing is
 * still correct in the only place it has to be.
 */

const fromEnv = (name: string, fallback: string): string => {
  const value: unknown = import.meta.env[name];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
};

export const LANDING_ORIGIN = fromEnv('VITE_LANDING_ORIGIN', 'https://socialsource.com.br');
export const APP_ORIGIN = fromEnv('VITE_APP_ORIGIN', 'https://app.socialsource.com.br');
export const OPS_ORIGIN = fromEnv('VITE_OPS_ORIGIN', 'https://ops.socialsource.com.br');
